import React, {useEffect, useState} from 'react';
import {Col, Row, Container, Form} from 'reactstrap';
import TextInput from '../../../Shared/TextInput/TextInput';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import LeadSuccess from '../leadSuccess';
import {isMobile} from 'react-device-detect';
import {connect} from 'react-redux';
import LeadAgreementsTooltip from '../../../Shared/LeadAgreementsTooltip/LeadAgreementsTooltip';
import {dwhLead} from '../dwhReports';
import {gtag4} from '../../../../utilities/analytics/tracking';
import Config from '../../../../Config';

const LeadForm = (props) => {
  const contentData = props?.data?.contentData;
  const {leadFormTitle, leadFormSubTitle, leadFormSuccessTitle, leadFormSuccessSubTitle, failureText, leadSendButton} = contentData;
  const isHorizontalMode = !isMobile && contentData?.isHorizontalMode;
  const isAgreementsCheckBoxActive = props.leadAgreementsData.leadAgreementsCheckBox;
  const leadsubject = props.leadAgreementsData.leadsubject;
  const sendButtonText = leadSendButton || 'שלח';
  const env_num = props.headerData?.tabIndex;
  const [envType, setEnvType] = useState('init');
  const [toolTipIsOpen, setToolTipIsOpen] = useState(false);
  const bgColors = ['black', 'white', 'purple', 'lightPurple', 'gradient'];
  const defaultColorForFormType = isHorizontalMode ? 'black' : 'gradient';
  const bgColor =
    (isMobile ? bgColors[props.leadAgreementsData.mobileBg] : bgColors[props.leadAgreementsData.desktopBg]) ?? defaultColorForFormType;
  const btnColor =
    (isMobile ? bgColors[props.leadAgreementsData.btnColorMobile] : bgColors[props.leadAgreementsData.btnColorDesktop]) ?? 'purple';

  useEffect(() => {
    if (isAgreementsCheckBoxActive) {
      gtag4({
        event: 'LeadBlock_Imp',
        title: leadFormTitle,
        section: leadsubject,
      });
    }
  }, []);

  useEffect(() => {
    if (env_num == 0) setEnvType('private');
    if (env_num == 1) setEnvType('buisness');
  }, [env_num]);

  function handleNameChange(e) {
    props.actions.setNameLead({
      name: e.target.getAttribute('name'),
      value: e.target.value,
    });
  }

  function handlePhoneChange(e) {
    props.actions.setPhoneLead({
      name: e.target.getAttribute('name'),
      value: e.target.value,
    });
  }

  function handleTooltipStatus(toolTipStatus) {
    setToolTipIsOpen(toolTipStatus);
  }

  async function handleSubmit(e) {
    e.preventDefault();

    handleDwh('ButtonClicked');

    const result = await props.actions.createLead();
    const response = result.payload?.response;
    if (response || response?.isSuccess) {
      gtag4({
        event: 'LeadBlock_FormSubmit',
        title: leadFormTitle,
        button: sendButtonText,
        section: leadsubject,
      });
    } else if (!response || !response?.isSuccess) {
      handleDwh('sendError');
      gtag4({
        event: 'LeadBlock_ErrorMessage',
        title: leadFormTitle,
        error: response?.returnCodeMessage,
        section: leadsubject,
      });
    } else if (result && !response?.collaborationUpdateSuccess && isAgreementsCheckBoxActive) {
      handleDwh('updateApprovalError');
    }
  }

  function handleDwh(errorType) {
    const fullName = props.data?.leadForm?.fullName;
    const phoneNumber = props.data?.leadForm?.phone;
    switch (errorType) {
      case 'ButtonClicked':
        dwhLead('Completed', 'Short Lead Block Button Clicked', isAgreementsCheckBoxActive, leadsubject, fullName, phoneNumber);
        break;
      case 'sendError':
        dwhLead('Error', 'Send Lead Error', isAgreementsCheckBoxActive, leadsubject, fullName, phoneNumber);
        break;
      case 'updateApprovalError':
        dwhLead('Error', 'Update Approval Consent Error', true, leadsubject, fullName, phoneNumber);
        break;
      default:
        break;
    }
  }

  let currentView = (
    <>
      {props.data.showSuccess ? (
        <div className={`layout-wrapper layout-bg-${bgColor}`}>
          <LeadSuccess title={leadFormSuccessTitle} subtitle={leadFormSuccessSubTitle} lead_type={envType} form_list={''} />
        </div>
      ) : (
        <div className={`layout-wrapper layout-bg-${bgColor}`}>
          <div className={`topContainer ${toolTipIsOpen ? 'tooltip-open' : ''}`}>
            <div className='container'>
              <div className='row'>
                <div className='col-12'>
                  <h1>{leadFormTitle}</h1>
                </div>
              </div>
              <div className='row'>
                <div className='col-12'>
                  <h2>{leadFormSubTitle}</h2>
                </div>
              </div>
              <div className='row'>
                <div className='col-12'>
                  <form onSubmit={handleSubmit}>
                    <div className='form-inputs-container'>
                      <span className='required-fields-text'>שדות עם כוכבית הם חובה</span>
                      <TextInput
                        error={props.data?.leadForm?.errors.fullName}
                        onChange={handleNameChange}
                        value={props.data?.leadForm?.fullName}
                        type='text'
                        placeholder='שם מלא'
                        id='fullName'
                        name='fullName'
                        maxLength='16'
                        autoComplete='off'
                        required='required'
                      />
                      <TextInput
                        error={props.data?.leadForm?.errors.phone}
                        onChange={handlePhoneChange}
                        value={props.data?.leadForm?.phone}
                        type='tel'
                        placeholder='מספר טלפון'
                        id='phone'
                        name='phone'
                        maxLength='10'
                        autoComplete='off'
                        required='required'
                      />
                    </div>
                  </form>
                </div>
              </div>
              {isAgreementsCheckBoxActive && (
                <div className='row lead-agreements-container'>
                  <div className='col-12'>
                    <LeadAgreementsTooltip leadAgreementsData={props.leadAgreementsData} sendTooltipStatus={handleTooltipStatus} />
                  </div>
                </div>
              )}
            </div>
          </div>

          <div className='bottomContainer'>
            <div className='layoutBottom'>
              <div className='container'>
                {props?.data?.showError && <div className='pt-2 pink-text' dangerouslySetInnerHTML={{__html: failureText}}></div>}
                {!isAgreementsCheckBoxActive && (
                  <div className='textContainer'>
                    <p>
                      {
                        Config.loginPageLegalText &&
                        <span dangerouslySetInnerHTML={{ __html: Config.loginPageLegalText }}></span>
                      }  
                    </p>
                  </div>
                )}
                {!toolTipIsOpen && (
                  <div className='buttonContainer'>
                    <BtnSubmit onclick={handleSubmit} className={`submit-btn-${btnColor}`} text={sendButtonText} formid='leadForm' />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );

  //isHorizontalMode
  if (isHorizontalMode) {
    if (isAgreementsCheckBoxActive) {
      currentView = (
        <>
          <div className={`layout-wrapper layout-bg-${bgColor}`}>
            {props.data.showSuccess ? (
              <LeadSuccess title={leadFormSuccessTitle} subtitle={leadFormSuccessSubTitle} lead_type={envType} form_list={''} />
            ) : (
              <>
                <div className='bottomContainerHorizontal'>
                  {props?.data?.showError && (
                    <div className='errorHorizontal' dangerouslySetInnerHTML={{__html: contentData?.failureText}}></div>
                  )}
                  <p className='subject'>{leadFormTitle}</p>
                  <div className='containerHorizontal agreementsCheckBoxActive'>
                    <form id='extendedLeadForm'>
                      <div className='row'>
                        <div className='col agreementsCheckBoxActive'>
                          <TextInput
                            error={props.data?.leadForm?.errors.fullName}
                            onChange={handleNameChange}
                            value={props.data?.leadForm?.fullName}
                            type='text'
                            placeholder='שם מלא'
                            id='fullName'
                            name='fullName'
                            maxLength='16'
                            autoComplete='off'
                            required='required'
                          />
                        </div>
                        <div className='col agreementsCheckBoxActive'>
                          <TextInput
                            error={props.data?.leadForm?.errors.phone}
                            onChange={handlePhoneChange}
                            value={props.data?.leadForm?.phone}
                            type='tel'
                            placeholder='מספר טלפון'
                            id='phone'
                            name='phone'
                            maxLength='10'
                            autoComplete='off'
                            required='required'
                          />
                        </div>
                      </div>
                      <div className='row horizontal-lead-agreements-container'>
                        <LeadAgreementsTooltip
                          leadAgreementsData={props.leadAgreementsData}
                          isHorizontalMode={true}
                          sendTooltipStatus={handleTooltipStatus}
                        />
                        <div className='buttonContainer agreementsCheckBoxActive'>
                          <BtnSubmit
                            className={`btn-submit agreementsCheckBoxActive submit-btn-${btnColor}`}
                            onclick={handleSubmit}
                            text={sendButtonText}
                            formid='leadForm'
                          />
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </>
            )}
          </div>
        </>
      );
    } else {
      currentView = (
        <>
          <div className={`layout-wrapper layout-bg-${bgColor}`}>
            {props.data.showSuccess ? (
              <LeadSuccess title={leadFormSuccessTitle} subtitle={leadFormSuccessSubTitle} lead_type={envType} form_list={''} />
            ) : (
              <>
                <div className='bottomContainerHorizontal'>
                  {props?.data?.showError && (
                    <div className='errorHorizontal' dangerouslySetInnerHTML={{__html: contentData?.failureText}}></div>
                  )}
                  <p className='subject'>{leadFormTitle}</p>
                  <div className='containerHorizontal'>
                    <form id='extendedLeadForm'>
                      <div className='row'>
                        <div className='col'>
                          <TextInput
                            error={props.data?.leadForm?.errors.fullName}
                            onChange={handleNameChange}
                            value={props.data?.leadForm?.fullName}
                            type='text'
                            placeholder='שם מלא'
                            id='fullName'
                            name='fullName'
                            maxLength='16'
                            autoComplete='off'
                            required='required'
                          />
                        </div>
                        <div className='col'>
                          <TextInput
                            error={props.data?.leadForm?.errors.phone}
                            onChange={handlePhoneChange}
                            value={props.data?.leadForm?.phone}
                            type='tel'
                            placeholder='מספר טלפון'
                            id='phone'
                            name='phone'
                            maxLength='10'
                            autoComplete='off'
                            required='required'
                          />
                        </div>
                        <div className='col buttonContainer'>
                          <BtnSubmit onclick={handleSubmit} text={sendButtonText} formid='leadForm' className={`submit-btn-${btnColor}`} />
                        </div>
                      </div>
                      <div className='row'>
                        <div className='textContainer'>
                          {
                            Config.loginPageLegalText &&
                            <span className='termsText' dangerouslySetInnerHTML={{ __html: Config.loginPageLegalText }}></span>
                          }  
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </>
            )}
          </div>
        </>
      );
    }
  }

  return <>{currentView}</>;
};

const mapStateToProps = (state) => {
  return {
    headerData: state.Header,
  };
};

export default connect(mapStateToProps)(LeadForm);
